module.exports = __webpack_public_path__ + "img/image_01.0d2c6aa5.jpeg";